import z from "zod";
import { env } from "@/lib/env";
import { LocalStorage } from "@/lib/local-storage";

export const consumeLoginAttempt = () => {
  const attempts = LocalStorage.get(LocalStorage.LOGIN_ATTEMPTS_KEY, z.coerce.number()) ?? 0;
  if (attempts > 2) {
    LocalStorage.remove(LocalStorage.LOGIN_ATTEMPTS_KEY);
    return false;
  }

  LocalStorage.set(LocalStorage.LOGIN_ATTEMPTS_KEY, attempts + 1, 15 * 60 * 1000); // expire in 15 minutes
  return true;
};

export const reloginUrl = (tryRelogin = true) => {
  return `${env.VITE_AUTH_PORTAL_URL}/manage/login/${tryRelogin ? `?next=${encodeURIComponent(`/manage/digifirst/create-token/${env.VITE_APP_ENV === "development" ? "?local=true" : ""}`)}` : ""}`;
};
